import Layout from '../components/Layout';
import Loading from '../components/Loading';
import Error from '../components/Error';
import NavigationControl from '../components/NavigationControl';

import "../styles/Checkout.css"
import { useNavigate } from 'react-router-dom';
import { useCheckout } from '../context/CheckoutContext';

function Checkout() {
    const { preview, isLoading, error } = useCheckout();
    const navigate = useNavigate()



    const nextButtonHandler = (e) => {
        navigate('/checkout/payment')
    }

    if (isLoading) return <Layout><Loading /></Layout>
    if (error) return <Error />
    return (
        <Layout>
            <NavigationControl />
            <br />
            <div className="preview">
                <div className="previewContainer">
                    <div className="previewCheckout">
                        <h2>Review</h2>
                        <br />
                        <p><b>Items total</b><span>₹{preview?.subTotal}</span></p>
                        <p><b>Discount</b><span>₹{preview?.discount}</span></p>
                        <p><b>Tax</b><span>₹{preview?.tax}</span></p>
                        <p><b>Shipping</b><span>₹{preview?.shippingFee}</span></p>
                    </div>
                    <p className='previewTotal'><b>Total payable</b><span>₹{preview?.totalAmount}</span></p>
                    <button className='btn' onClick={nextButtonHandler}>Next</button>
                </div>
            </div>


        </Layout>
    )
}

export default Checkout